<script>
  import FormInput from '@/components/Form/Input';

  export default {
    components: {
      FormInput,
    },

    data: () => ({
      email: '',
      password: '',
    }),

    methods: {
      login () {
        this.$router.push('/documentos');
      },
    },
  };
</script>

<template>
  <form>
    <FormInput
      floating
      type="email"
      label="Email"
      v-model="email"
      />

    <FormInput
      floating
      label="Senha"
      type="password"
      v-model="password"
      />

    <button
      class="auth__action"
      @click.prevent="login"
      >
      Entrar
    </button>
  </form>
</template>
